<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select v-model="listQuery.tenantId" placeholder="选择租户" clearable style="width: 200px" class="filter-item">
        <el-option v-for="item in tenantList" :key="item.tenantId" :label="item.name" :value="item.tenantId" />
      </el-select>
      <el-input v-model="listQuery.title" placeholder="标题" style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="success" icon="el-icon-plus" @click="handleCreate">新增</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="ID" prop="quickReplyId" align="center" width="80" />
      <el-table-column label="租户" prop="tenantName" align="center" width="120" />
      <el-table-column label="分类" prop="category" align="center" width="120" />
      <el-table-column label="标题" prop="title" align="center" />
      <el-table-column label="内容" prop="content" align="center" show-overflow-tooltip />
      <el-table-column label="快捷键" prop="shortcut" align="center" width="100" />
      <el-table-column label="使用次数" prop="usageCount" align="center" width="100" />
      <el-table-column label="是否全局" prop="isGlobal" align="center" width="100">
        <template slot-scope="{row}">
          <el-tag :type="row.isGlobal ? 'success' : 'info'">{{ row.isGlobal ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="100px" style="width: 400px; margin-left:50px;">
        <el-form-item label="所属租户" prop="tenantId">
          <el-select v-model="temp.tenantId" placeholder="请选择租户" style="width: 100%;">
            <el-option v-for="item in tenantList" :key="item.tenantId" :label="item.name" :value="item.tenantId" />
          </el-select>
        </el-form-item>
        <el-form-item label="分类" prop="category">
          <el-input v-model="temp.category" />
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="temp.title" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="temp.content" type="textarea" :rows="4" />
        </el-form-item>
        <el-form-item label="快捷键" prop="shortcut">
          <el-input v-model="temp.shortcut" />
        </el-form-item>
        <el-form-item label="是否全局" prop="isGlobal">
          <el-switch v-model="temp.isGlobal" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listQuickReplies, createQuickReply, updateQuickReply, deleteQuickReply } from '@/api/quickReply'
import { listTenants } from '@/api/tenant'
import Pagination from '@/components/Pagination'

export default {
  name: 'QuickReplyList',
  components: { Pagination },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      tenantList: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        tenantId: undefined,
        title: undefined
      },
      temp: {},
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      rules: {
        tenantId: [{ required: true, message: '请选择租户', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'change' }],
        content: [{ required: true, message: '请输入内容', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getTenantList()
    this.getList()
  },
  methods: {
    getTenantList() {
      listTenants({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.tenantList = response.data.records || []
      })
    },
    getList() {
      this.listLoading = true
      listQuickReplies(this.listQuery).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    resetTemp() {
      this.temp = {
        tenantId: undefined,
        category: '',
        title: '',
        content: '',
        shortcut: '',
        isGlobal: false
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createQuickReply(this.temp).then(() => {
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        }
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const data = {
            category: this.temp.category,
            title: this.temp.title,
            content: this.temp.content,
            contentType: this.temp.contentType,
            richContent: this.temp.richContent,
            shortcut: this.temp.shortcut,
            sortOrder: this.temp.sortOrder,
            isActive: this.temp.isActive
          }
          updateQuickReply(this.temp.quickReplyId, data).then(() => {
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
            this.getList()
          })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该快捷回复吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteQuickReply(row.quickReplyId).then(() => {
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
          this.getList()
        })
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.filter-item {
  margin-right: 10px;
}
</style>
